import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { IBancontactPaymentIntentDtoOut, IPaymentIntentDtoIn, IPaymentIntentDtoOut } from '../interfaces/stripe.interface';
import { HeaderErrorEnum } from '../enums/header-error.enum';
import { SubUrlsEnum } from '../enums/sub-urls.enum';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root',
})
export class StripePaymentService {
    constructor(private http: HttpClient, private translate: TranslateService) {}

    public createPaymentIntent(paymentIntent: IPaymentIntentDtoOut | IBancontactPaymentIntentDtoOut): Observable<IPaymentIntentDtoIn> {
        const headers: HttpHeaders = new HttpHeaders().set(HeaderErrorEnum.OWN_ERROR, 'true');
        if (Object.prototype.hasOwnProperty.call(paymentIntent.payment_intent, 'currency')) {
            let params: HttpParams = new HttpParams().set('payment_method_types[]', 'bancontact');
            params = params.set('payment_method_options[preferred_language]', this.translate.currentLang);
            params = params.set('statement_descriptor', 'WanaSchool Reload Description');

            return this.http.post<IPaymentIntentDtoIn>(
                environment.wasoApi + SubUrlsEnum.PAYMENT_INTENT,
                { ...paymentIntent },
                { headers, params }
            );
        } else {
            return this.http.post<IPaymentIntentDtoIn>(environment.wasoApi + SubUrlsEnum.PAYMENT_INTENT, { ...paymentIntent }, { headers });
        }
    }
}
